export default __webpack_public_path__ + "static/media/ico-aws-policy-circle.20d447fe.svg";